import React from 'react';

function Avatar({ src, alt, size = 'md', status }) {
  const sizeClasses = {
    xs: 'h-6 w-6',
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  };

  const statusColors = {
    online: 'bg-green-400',
    offline: 'bg-gray-400',
    busy: 'bg-red-400',
    away: 'bg-yellow-400',
  };

  return (
    <div className="relative">
      <img
        className={`${sizeClasses[size]} rounded-full object-cover`}
        src={src || '/placeholder-avatar.png'}
        alt={alt || 'Avatar'}
      />
      {status && (
        <span
          className={`absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white ${statusColors[status]}`}
        ></span>
      )}
    </div>
  );
}

export default Avatar;